import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { Icon } from '../Icon/Icon';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { useTextStyle } from '../Text/useTextStyle';
import { FlexContainer } from '../layout/FlexContainer';
const StyledInput = styled('input', (p) => ({
    ...p.$style,
    height: sizes.editableTagCreateInput.height,
    background: 'none',
    border: 'none',
    caretColor: staticColors.inputCaret,
    outline: 'none',
}));
export const EditableTagCreateInput = ({ addButtonText, disabled, testId, onCreate, }) => {
    const [showInput, setShowInput] = useState(false);
    const [value, setValue] = useState('');
    const buttonTestId = testId ? `${testId}-button` : undefined;
    const inputTestId = testId ? `${testId}-input` : undefined;
    const inputTestIdAttribute = useTestIdAttribute(inputTestId);
    const inputStyle = useTextStyle({
        font: 'primary',
        variant: 's2',
        color: 'dark',
        underline: false,
    });
    const handleAddButtonClick = () => {
        setShowInput(true);
    };
    const handleInputChange = (e) => setValue(e.target.value);
    const handleInputBlur = () => {
        setShowInput(false);
    };
    const handleInputKeyDown = (e) => {
        if (e.key === 'Enter') {
            setValue('');
            onCreate(value);
        }
        if (e.key === 'Escape') {
            setValue('');
            setShowInput(false);
        }
    };
    const buttonTextAndIconColor = disabled
        ? 'grey'
        : 'action';
    const button = (_jsx(PlainButton, { disabled: disabled, testId: buttonTestId, onClick: handleAddButtonClick, children: _jsxs(FlexContainer, { verticalAlign: 'center', height: sizes.editableTagCreateInput.height, children: [_jsx(Icon, { name: 'Add', size: 'small', color: buttonTextAndIconColor }), _jsx(Text, { variant: 'b2', color: buttonTextAndIconColor, children: addButtonText })] }) }));
    const input = (_jsx(StyledInput, { $style: inputStyle, size: value.length, value: value, autoFocus: true, ...inputTestIdAttribute, onKeyDown: handleInputKeyDown, onChange: handleInputChange, onBlur: handleInputBlur }));
    return showInput ? input : button;
};
